import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, Header, Icon, Divider, Button } from 'semantic-ui-react';
import i18next from 'i18next';
import SideEditor from '../../general/SideEditor';
import RestaurantSettingsEditor from '../home/RestaurantSettingsEditor';
import { fetchRestaurant, updateActivityPeriods, setEditedEntity } from '../../../actions';
import { WeekScheduler } from '../../common';

import './RestaurantDetails.scss';

// TODO: Fix scrolling (appears for a very short time on mac)
// TODO: Page doesn't rerender, when the schedule updates
class RestaurantDetails extends Component {
    componentDidMount() {
        if (this.props.restaurant.id) {
            this.props.fetchRestaurant(this.props.restaurant.id);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.restaurant.id !== prevProps.restaurant.id && this.props.restaurant.id) {
            this.props.fetchRestaurant(this.props.restaurant.id);
        }
    }

    render() {
        const { restaurant } = this.props;
        const { name: posSupplier } = this.props.posSuppliers.find(pos => pos.id == restaurant.posSupplierId) || {};

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('restaurant')}
                    visible={this.props.editedType === 'restaurantConfig'}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <RestaurantSettingsEditor />
                </SideEditor>
                <Grid>
                    <Grid.Row className="pi-restaurant-details-row">
                        <Grid.Column className="pi-restaurant-details-column">
                            <figure className="pi-restaurant-details-figure">
                                <figcaption className="pi-restaurant-details-caption">
                                    <div className="pi-restaurant-details-caption-content">
                                        <h1>{restaurant.name}</h1>
                                        <h3>{restaurant.address}</h3>
                                        <h3>{posSupplier}</h3>
                                    </div>

                                    <Button
                                        floated="right"
                                        circular
                                        size='large'
                                        icon='setting'
                                        color='yellow'
                                        style={{ margin: '0 20px' }}
                                        onClick={() => this.props.setEditedEntity('restaurantConfig', restaurant)}
                                    />
                                </figcaption>
                            </figure>
                        </Grid.Column>
                    </Grid.Row>
                    {restaurant.openingHours ?
                        [<Grid.Row key={1} className='pi-restaurant-openning-hours-title'>
                            <Grid.Column>
                                <Divider section horizontal>
                                    <Header icon textAlign='center' className='pi-restaurant-openning-hours-header'>
                                        <Icon name='hourglass half' circular />
                                        <Header.Content>{i18next.t('openingHours')}</Header.Content>
                                    </Header>
                                </Divider>
                            </Grid.Column>
                        </Grid.Row>,
                        <Grid.Row key={2} style={{ overflowX: 'auto' }}>
                            <Grid.Column>
                                <WeekScheduler
                                    restaurant={restaurant}
                                    schedule={restaurant.openingHours}
                                    updatePeriods={(periods, successCallback) => this.props.updateActivityPeriods(restaurant.id, periods, successCallback)}
                                    />
                            </Grid.Column>
                        </Grid.Row>]
                        : null}
                </Grid>
            </div >
        );
    }
}

RestaurantDetails.propTypes = {
    restaurant: PropTypes.object,
    posSuppliers: PropTypes.array,
    fetchRestaurant: PropTypes.func,
    editedType: PropTypes.string,
    setEditedEntity: PropTypes.func,
    updateActivityPeriods: PropTypes.func,
    
};

const mapStateToProps = (state, ownProps) => {
    const restaurant = state.businessApp.restaurants.find(rest => rest.id === ownProps.match.params.restId) || {};
    const { posSuppliers } = state.meta;
    const { type: editedType } = state.editor;

    return { restaurant, posSuppliers, editedType };
};

export default connect(mapStateToProps, { fetchRestaurant, updateActivityPeriods, setEditedEntity })(RestaurantDetails);
